// 🔧 auction_seeder.js
// ✅ Purpose: Seeds Silent Auction demo data into Firestore
// ✅ Features:
// - Coordinates persistence of auction demo data
// - Calls repository layer only
// - No Firestore logic here
// - Returns standardized results to Builder
// - Fully block-commented for clarity and future devs

import { saveAuctionItems } from "./auction_repository";

export const seedAuction = async ({
  demoContext,
  auctionPlan,
} = {}) => {
  console.log("🌱 Auction Seeder started.");

  if (!auctionPlan) {
    throw new Error("Auction Seeder requires auctionPlan.");
  }

  const results = await saveAuctionItems({
    demoContext,
    items: auctionPlan.items || [],
    bids: auctionPlan.bids || [],
  });

  console.log("✅ Auction Seeder completed.", {
    items: results.items.length,
  });

  return results;
};
